import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppSelector } from '../../../Reducers/store';
import OrderApi from '../../../Api/OrderApi';
import { Order, OrderStatusStringEnums } from '../../../Models/Order';
import { FileTypeEnums } from '../../../Models/FileType';
import { formatNumbers } from '../../../Utils';
import blankImage from '../../../Assets/NoPhoto.jpg';

export default function OrderDetail() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [orderData, setorderData] = useState<Order | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getOrder = () => {
    if (id) {
      setIsLoading(true);
      OrderApi.getOrder(Number(id))
        .then((res) => {
          setorderData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setorderData(null);
    }
  };

  useEffect(() => {
    getOrder();
  }, [id]);

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1 gap-3 items-center'>
            <h1 className='text-gray-900 font-bold text-4xl'>Order Details</h1>
          </div>
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            <div className='w-full mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    Order Status:{' '}
                    {OrderStatusStringEnums[orderData?.orderStatusId ?? 0]}
                  </span>
                </div>
                <hr className='bg-gray-300 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>User:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.user?.firstName ?? ''}{' '}
                      {orderData?.user?.lastName ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Client:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.client?.name ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Account #:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.client?.accountNumber ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>PO Number:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.ponumber ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Contact Name:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.contactName ?? ''}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Contact Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.contactPhone}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Contact Email:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.contactEmail}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Billing Adddress:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.billingAddress?.address1}
                      {', '}
                      {orderData?.billingAddress?.city}
                      {', '}
                      {orderData?.billingAddress?.state?.code}{' '}
                      {orderData?.billingAddress?.zip}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Shipping Adddress:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {orderData?.shippingAddress?.address1}
                      {', '}
                      {orderData?.shippingAddress?.city}
                      {', '}
                      {orderData?.shippingAddress?.state?.code}{' '}
                      {orderData?.shippingAddress?.zip}
                    </div>
                  </div>
                  <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2 pt-5'>
                    <span className='tracking-wide uppercase text-xl'>
                      Items
                    </span>
                  </div>
                  <hr className='bg-gray-300 h-[5px]'></hr>
                  <div className='w-full mb-2 flex justify-between'>
                    <div className='flex flex-col px-0 text-md lg:px-5 md:text-lg lg:text-xl items-start gap-2'>
                      {orderData?.orderItems?.map((item) => (
                        <div key={item.id} className='flex justify-center'>
                          <img
                            key={item.id}
                            src={
                              item.equipment?.files &&
                              item.equipment?.files?.filter(
                                (x) => x.fileTypeId === FileTypeEnums.Photo
                              ).length > 0
                                ? item.equipment?.files.filter(
                                    (x) => x.fileTypeId === FileTypeEnums.Photo
                                  )[0].fileUrl
                                : blankImage
                            }
                            alt={item.equipment?.number + '-image'}
                            className='h-[150px] object-contain m-auto'
                          />
                          <div className='ml-2'>
                            <div>
                              Manufacturer: {item.equipment?.manufacturer?.name}
                            </div>
                            <div>Part #: {item.equipment?.number}</div>
                            <div>Quantity: {item.quantity}</div>
                            <div>
                              Price Estimate: $
                              {formatNumbers(
                                (item.equipment?.price ?? 1) * item.quantity
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
